// extracted by mini-css-extract-plugin
module.exports = {"cookiesSettingWrapper":"settingList_cookiesSettingWrapper__U1avW","title":"settingList_title__ip5pl","status":"settingList_status__T0aBa","content":"settingList_content__6kZj8"};